<script setup lang="ts">
import Box from '@uiKit/elements/Box.vue'
import AppImage from '@uiKit/elements/Image.vue'
import Text from '@uiKit/elements/Text.vue'
import arrowBackIcon from '@assets/images/propertyDetail/arrow-back.svg'

// "← Back to Property List" crumb above the gallery (Figma 32746:92909).

interface Props {
  label: string
}

defineProps<Props>()

defineEmits<{ (e: 'back'): void }>()
</script>

<template>
  <Box is="button" type="button" align="center" gap="2" class="pd-back" @click="$emit('back')">
    <Box class="pd-back__icon" aria-hidden="true">
      <AppImage :src="arrowBackIcon" alt="" class="pd-back__arrow" />
    </Box>
    <Text
      type="body"
      weight="medium"
      color="primary"
      is="span"
      style="line-height: 1.3; letter-spacing: -0.14px"
      >{{ label }}</Text
    >
  </Box>
</template>

<style scoped>
.pd-back {
  align-self: flex-start;
  padding: 0;
  border: none;
  background: none;
  cursor: pointer;
}

.pd-back:focus-visible {
  outline: 2px solid var(--p-primary-500);
  outline-offset: 4px;
  border-radius: 4px;
}

/* 14×12 slot; the stroked arrow overhangs it the way the Figma vector does. */
.pd-back__icon {
  position: relative;
  flex-shrink: 0;
  width: 14px;
  height: 12px;
}

.pd-back__arrow {
  position: absolute;
  top: -0.8px;
  left: -1.13px;
  display: block;
}
</style>
